import React from 'react';
import { Link } from 'react-router-dom';

interface NoDataPlaceholderProps {
  title: string;
  message: React.ReactNode;
}

const NoDataPlaceholder: React.FC<NoDataPlaceholderProps> = ({ title, message }) => {
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: 'calc(100vh - 80px)',
      padding: '2rem'
    }}>
      <div style={{ 
        maxWidth: '600px', 
        background: '#fff', 
        borderRadius: '12px', 
        padding: '2rem',
        boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
        textAlign: 'center'
      }}>
        <div style={{ marginBottom: '1.5rem' }}>
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#3949ab" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 8V12" stroke="#3949ab" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 16H12.01" stroke="#3949ab" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#333' }}>{title}</h2>
        <div style={{ fontSize: '1rem', lineHeight: '1.5', color: '#666', marginBottom: '1.5rem' }}>
          {message}
        </div>
        <Link to="/settings" style={{ 
          display: 'inline-block',
          background: 'linear-gradient(115deg, rgb(34, 34, 69) 25%, rgb(-77, 182, 159) 162%)', 
          color: 'white', 
          padding: '0.75rem 1.5rem', 
          borderRadius: '4px', 
          textDecoration: 'none',
          fontWeight: 500
        }}>
          Go to Settings
        </Link>
      </div>
    </div>
  );
};

export default NoDataPlaceholder;
